import React, { Component } from "react";
import Logo from "../components/Logo";
import Disc from "../components/Disc";
import Loading from "../components/Loading";
import { css } from "aphrodite";
import { styles } from "./DashboardStyles";
import { dashboardActions, popupActions } from "../_actions";
import { connect } from "react-redux";
import { isEmpty } from "../_helpers";

import Popup from "reactjs-popup";
import { history } from "../_helpers";

import "../style/popup.css";

class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.props.dispatch(dashboardActions.getDetail());

    this.state = { popupShouldDisplay: false };

    this.closeModal = this.closeModal.bind(this);
  }
  closeModal() {
    this.setState({ popupShouldDisplay: false });

    let oldUser = JSON.parse(localStorage.getItem("user"));
    const user = {
      ...oldUser,
      popupShouldDisplay: false,
    };
    localStorage.setItem("user", JSON.stringify(user));

    this.props.dispatch(
      popupActions.saveClose(this.props.popup.detail[0].popup_id)
    );
  }
  getTodaysDate() {
    const dateTime = new Date();
    const locale = "en-us";
    const date = `${dateTime.getDate()} ${dateTime.toLocaleString(locale, {
      month: "long",
    })} ${dateTime.getFullYear()}`;
    this.setState({
      date: date,
      time: `${dateTime.toLocaleString(locale, {
        weekday: "long",
      })} ${dateTime.toLocaleString(locale, {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      })}`,
    });
  }
  componentWillMount() {
    let { num_alerts } = JSON.parse(localStorage.getItem("user"));

    if (num_alerts > 0) {
      const prevPath =
        (this.props.history.location.state &&
          this.props.history.location.state.prevPath) ||
        false;
      prevPath == "login" && history.push("/parents-home");
    }

    this.getTodaysDate();
    // <Route render={({ history }) => history.push("/404")} />;

    this.props.dispatch(popupActions.getDetail());
  }

  renderPopup() {
    try {
      const { title, message } = this.props.popup.detail[0];
      return (
        <Popup
          onClose={this.closeModal}
          defaultOpen={true}
          modal={true}
          position="right center"
        >
          <div>
            <h1 className="popup-title">{title}</h1>
            <p className="popup-desc">{message}</p>
            <button className="popup-close" onClick={this.closeModal}>
              Okay
            </button>
          </div>
        </Popup>
      );
    } catch (e) {}
  }

  renderDashboards() {
    return (
      <ul className={css(styles.devices)}>
        {this.props.dashboard.detail.map((item, i) => {
          return (
            <li className={css(styles.device)} key={i}>
              <a
                href={item.dashboard_type === 1 ? "/my-home" : "/parents-home"}
                className={css(styles.link)}
              >
                <div className={css(styles.discWrapper)}>
                  {item.dashboard_type === 1 && (
                    <Disc
                      title={item.title}
                      icon={"/icons/HomeIcon.svg"}
                      state={"home"}
                    />
                  )}
                  {item.dashboard_type === 2 && !item.icon && (
                    <Disc
                      title={item.title}
                      icon={"/icons/InfoCareIcon.svg"}
                      state={"parentsHome"}
                    />
                  )}
                  {item.dashboard_type === 2 && item.icon && (
                    <img
                      className={css(styles.infoCareImage)}
                      src={`data:${item.icon}`}
                    />
                  )}
                </div>
                <strong className={css(styles.title)}>
                  {item.dashboard_type === 1 ? (
                    <img
                      src="/homeview-logo.svg"
                      alt=""
                      className={css(styles.homeViewLogo)}
                    />
                  ) : (
                    <img
                      src="/infocare-logo.svg"
                      alt=""
                      className={css(styles.infoCareLogo)}
                    />
                  )}
                </strong>
                {!isEmpty(item.messages) && (
                  <span className={css(styles.description)}>
                    Today&#39;s balance is {item.messages[0].currency_unit}
                    {item.messages[0].value}
                  </span>
                )}
              </a>
            </li>
          );
        })}
      </ul>
    );
  }
  render() {
    const fetchingDetail = this.props.fetchingDetail;
    const error = this.props.dashboard.error;

    return (
      <div className={css(styles.container)}>
        {!this.props.popup.fetchingDetail &&
          this.props.popup &&
          this.props.popup.detail &&
          this.props.popup.detail.length > 0 &&
          this.renderPopup()}
        <div className={css(styles.innerContainer)}>
          <Logo />
          <div className={css(styles.dateTime)}>
            <strong className={css(styles.date)}>{this.state.date}</strong>
            <div className={css(styles.time)}>{this.state.time}</div>
          </div>
          <div className={css(styles.content)}>
            {fetchingDetail && (
              <Loading onDark={true} title="Fetching dashboards" />
            )}
            {!fetchingDetail &&
              !isEmpty(this.props.dashboard.detail) &&
              this.renderDashboards()}
          </div>
          <a href="/login" className={css(styles.signOut)}>
            Sign Out
          </a>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { fetchingDetail } = state.dashboard;
  const { alert } = state;
  const dashboard = state.dashboard;
  const popup = state.popup;
  return {
    fetchingDetail,
    alert,
    dashboard,
    popup,
  };
}

export default connect(mapStateToProps)(Dashboard);
